export default __webpack_public_path__ + "static/media/keep_it_alight_icon.8509b2a2.png";